import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateName, validateName2, ValidText } from "../../contexts/Utils";
import {
  EditProductApi,
  GetAllBrands,
  GetAllCategories,
  GetAllUnits,
  GetProductById,
  GetProductImagesById,
  EditProductImagesById,
  AddProductImage,
  //GetProductVideoById,
  CheckProdNameCodeExist,
  EditProductImageNumberById,
  AddImage,
  RemoveImage,
  RemoveProductImageById,
  GetProductImageKeyById,
  GetAllTags,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddProduct.css";
import { Container, Col, Row } from "react-bootstrap";
import imageCompression from "browser-image-compression";
import Select from "react-select";

const EditProduct = () => {
  const { currentColor, productImageLimit, userID, userToken } =
    useStateContext();
  let param = useParams();
  const fileInputRef = useRef([]);
  // const fileInputImgRef1 = useRef(null);
  // const fileInputImgRef2 = useRef(null);
  // const fileInputImgRef3 = useRef(null);
  // const fileInputImgRef4 = useRef(null);

  const [Unit, setUnit] = useState("select");
  // const [videoBlob, setVideoBlob] = useState(null);
  // const [videoBlob1, setVideoBlob1] = useState(null);
  // const [videoBlob2, setVideoBlob2] = useState(null);
  // const [pexist, setpexist] = useState("");
  const [Category, setCategory] = useState("select");
  const [Brand, setBrand] = useState("select");
  const [Tag, setTag] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [DisplayProduct, setDisplayProduct] = useState(1);
  const [ActiveProduct, setActiveProduct] = useState(1);
  // const [ProductImage, setProductImage] = useState("");
  const [getunits, setUnits] = useState([]);
  const [getbrands, setbrands] = useState([]);
  const [gettags, setTags] = useState([]);
  const [getcategories, setCategories] = useState([]);
  // const [uploadedImage, setUploadedImage] = useState(null);
  const [Details, setDetails] = useState("");
  const [UnitPrice, setUnitPrice] = useState(0);
  const [Code, setCode] = useState("");
  const [Name, setName] = useState("");
  const [Name2, setName2] = useState("");
  const [loadBtn, setLoadBtn] = useState(false);
  const [editImg, setEditImg] = useState(false);

  const [Code1, setCode1] = useState("");
  const [Name1, setName1] = useState("");
  const [Discount, setDiscount] = useState(0);
  // const [ProdImage, setProdImage] = useState("");
  // const [Flag, setFlag] = useState(0);
  // const [imgExist, setimgExist] = useState(0);
  const [ValError, setValError] = useState([]);
  // const [flag, setflag] = useState(false);
  const [vflag, setvflag] = useState(0);
  // const [visibleCard, setVisibleCard] = useState(1);
  const [images, setImages] = useState([]);
  const [oldImages, setOldImages] = useState([]);
  const dragImage = useRef(0);
  const draggedOverImage = useRef(0);
  const [sortImage, setSortImage] = useState(false);

  function handleSort() {
    if (editImg === true) {
      const peopleClone = [...images];
      const idds = peopleClone[dragImage.current].id;
      const idds1 = peopleClone[draggedOverImage.current].id;
      // const prev = peopleClone[dragImage.current].preview;
      // const prev1 = peopleClone[draggedOverImage.current].preview;

      // if (prev && prev1 && idds !== idds1) {
      const temp = peopleClone[dragImage.current];
      peopleClone[dragImage.current] = peopleClone[draggedOverImage.current];
      peopleClone[dragImage.current].id = idds;
      peopleClone[draggedOverImage.current] = temp;
      peopleClone[draggedOverImage.current].id = idds1;

      setSortImage(true);
      setImages(peopleClone);
      // }
    }
  }

  const navigate = useNavigate();

  const validName1 = (name, ii) => {
    const updatedErrors = [...ValError];
    if (name.trim().length === 0) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return false;
    }
    if (validateName(name)) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return true;
    }
    updatedErrors[ii] = "Invalid field!";
    setValError(updatedErrors);
    return false;
  };

  const validName2 = (name, ii) => {
    const updatedErrors = [...ValError];
    if (name.trim().length === 0) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return false;
    }
    if (validateName2(name)) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return true;
    }
    updatedErrors[ii] = "Invalid field!";
    setValError(updatedErrors);
    return false;
  };
  // const handleClickRemoveVideo = () => {
  //   setVideoBlob(null);
  //   if (videoBlob1) {
  //     setVideoBlob1(null);
  //     setvflag(1);
  //   }
  //   console.log(fileInputRef);
  //   fileInputRef.current.value = "";
  // };

  const handleClickRemoveImage = (id, fInput) => {
    fInput.current[id].value = "";
    setImages((prevImages) =>
      prevImages.map((image) =>
        image.id === id
          ? {
              ...image,
              url: null,
              file: null,
              preview: null,
            }
          : image,
      ),
    );
    // if (id === 1) {
    //   fileInputImgRef1.current.value = "";
    // }
    // if (id === 2) {
    //   fileInputImgRef2.current.value = "";
    // }
    // if (id === 3) {
    //   fileInputImgRef3.current.value = "";
    // }
    // if (id === 4) {
    //   fileInputImgRef4.current.value = "";
    // }
  };

  // const handleVideoFileChange = (event) => {
  //   const file = event.target.files[0];
  //   // console.log("heh");
  //   if (file.size > 31457280) {
  //     alert("Video file max size is 30mb");
  //     return;
  //   }
  //   setvflag(1);
  //   if (file) {
  //     setLoading(true);
  //     const reader = new FileReader();

  //     reader.onloadend = () => {
  //       // Convert the result to a Blob
  //       //const blob = new Blob([reader.result], { type: file.type });
  //       setVideoBlob(file);
  //       setLoading(false);
  //       if (file) {
  //         setflag(false);
  //       } else {
  //         setVideoBlob(null);
  //       }
  //     };

  //     // Read the file as a binary string
  //     reader.readAsArrayBuffer(file);
  //   }
  // };

  const ValidText1 = (txt, ii) => {
    const updatedErrors = [...ValError];
    if (txt.trim().length === 0) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return false;
    }
    if (ValidText(txt)) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return true;
    }
    updatedErrors[ii] = "Invalid field!";
    setValError(updatedErrors);
    return false;
  };

  const handleChangeName = (e) => {
    setName(e.target.value);
  };

  const handleChangeName2 = (e) => {
    setName2(e.target.value);
  };

  const handleChangeCode = (e) => {
    setCode(e.target.value);
  };

  const handleChangeDetails = (e) => {
    setDetails(e.target.value);
  };

  const handleChangeDiscount = (e) => {
    setDiscount(e.target.value);
  };

  const handleChangeUnitPrice = (e) => {
    setUnitPrice(e.target.value);
  };

  const handleChangeUnit = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        // console.log(selectedOption);
        setUnit(selectedOption);
        const updatedErrors = [...ValError];
        updatedErrors[4] = "";
        setValError(updatedErrors);
      } else {
        setUnit("Select Unit");
      }
    } catch (err) {}
  };

  const handleChangeCategory = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        setCategory(selectedOption);
        const updatedErrors = [...ValError];
        updatedErrors[5] = "";
        setValError(updatedErrors);
      } else {
        setCategory("Select Category");
      }
    } catch (err) {}
  };

  const handleChangeBrand = (selectedOption) => {
    try {
      if (selectedOption && selectedOption.value) {
        setBrand(selectedOption);
        const updatedErrors = [...ValError];
        updatedErrors[6] = "";
        setValError(updatedErrors);
      } else {
        setBrand("Select Brand");
      }
    } catch (err) {}
  };

  const handleChangeTag = (selectedOptions) => {
    setTag(selectedOptions || []);
  };

  const handleChangeDisplay = (e) => {
    setDisplayProduct((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeEditImg = (e) => {
    setEditImg((prev) => (prev === false ? true : false));
  };

  const handleChangeActive = (e) => {
    setActiveProduct((prev) => (prev === 0 ? 1 : 0));
  };

  const handleBackClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      // console.log("Back");
      navigate("/Product");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const handleImageChange1 = (e) => {
  //   setProdImage("");
  //   setFlag(1);
  //   setimgExist(1);
  //   const file = e.target.files[0];
  //   setProductImage(file);
  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     setUploadedImage(reader.result);
  //   };
  //   reader.readAsDataURL(file);
  // };

  const handleImageChange = (e, imageID, fInput) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 4194304) {
        alert("Image File max size is 4 MB!");
        fInput.current[imageID].value = "";
        setImages((prevImages) =>
          prevImages.map((image) =>
            image.id === imageID
              ? {
                  ...image,
                  url: null,
                  file: null,
                  preview: null,
                }
              : image,
          ),
        );
        e.target.value = null;
        return;
      } else {
        const updatedImg = images.map((image) =>
          image.id === imageID
            ? {
                ...image,
                url: null,
                file,
                preview: file ? URL.createObjectURL(file) : null,
                fileInput: fInput,
              }
            : image,
        );
        //console.log(updatedImg);
        setImages(updatedImg);

        // if (imageID === visibleCard) {
        //   const nextVisibleCard = Math.min(visibleCard + 1, images.length);
        //   setVisibleCard(nextVisibleCard);
        // }
      }
    }
  };

  const insertImage = async (imgg, i) => {
    const options = {
      maxSizeMB: 0.04, // Maximum file size in MB
      maxWidthOrHeight: 1000, // Maximum width or height of the image
      useWebWorker: true, // Use web worker for faster compression
      fileType: "image/webp", // ✅ Convert to WebP
    };
    const options1 = {
      maxSizeMB: 0.15, // Maximum file size in MB
      maxWidthOrHeight: 5000, // Maximum width or height of the image
      useWebWorker: true, // Use web worker for faster compression
      fileType: "image/webp", // ✅ Convert to WebP
    };

    try {
      // var imggg = imgg;
      // var imggg1 = imgg;
      if (imgg) {
        const compressedFile = await imageCompression(imgg, options);
        const compressedFile1 = await imageCompression(imgg, options1);
        // imggg = compressedFile;
        // imggg1 = compressedFile1;
        // console.log("Original file:", imgg.size);
        // console.log("Compressed file:", imggg.size);
        // console.log("Compressed1 file:", imggg1.size);
        var f_name = Name.substring(0, Math.min(50, Name.length))
          .split(" ")
          .join("_");
        f_name = f_name + "_" + i.toString() + "_";
        const response1 = await AddImage(
          f_name + "sm",
          "PRODUCT",
          compressedFile,
          userID,
          userToken,
        );
        const data1 = await response1.data;
        if (data1.imageUrl) {
          const response2 = await AddImage(
            f_name + "lg",
            "PRODUCT",
            compressedFile1,
            userID,
            userToken,
          );
          const data2 = await response2.data;
          if (data2.imageUrl) {
            const response = await AddProductImage(
              param.p_id,
              i,
              null, // imggg,
              null, // imggg1,
              data2.fileKey,
              data1.fileKey,
              data2.publicUrl,
              data1.publicUrl,
              data2.imageUrl,
              data1.imageUrl,
              data2.cdnUrl,
              data1.cdnUrl,
              "",
              "",
              userID,
              userToken,
            );
            if (response.status === 200) {
            } else {
              alert("Product image failed to upload");
            }
          } else {
            alert("Product image failed to upload");
          }
        } else {
          alert("Product image failed to upload");
        }
      }
    } catch (error) {
      console.error("Error compressing the image:", error);
    }
  };

  const updateImage = async (imgg, image_idd, i) => {
    const options = {
      maxSizeMB: 0.04, // Maximum file size in MB
      maxWidthOrHeight: 1000, // Maximum width or height of the image
      useWebWorker: true, // Use web worker for faster compression
      fileType: "image/webp", // ✅ Convert to WebP
    };
    const options1 = {
      maxSizeMB: 0.15, // Maximum file size in MB
      maxWidthOrHeight: 5000, // Maximum width or height of the image
      useWebWorker: true, // Use web worker for faster compression
      fileType: "image/webp", // ✅ Convert to WebP
    };

    try {
      // var imggg = imgg;
      // var imggg1 = imgg;
      if (imgg) {
        const compressedFile = await imageCompression(imgg, options);
        const compressedFile1 = await imageCompression(imgg, options1);
        // imggg = compressedFile;
        // imggg1 = compressedFile1;
        // console.log("Original file:", imgg.size);
        // console.log("Compressed file:", imggg.size);
        // console.log("Compressed1 file:", imggg1.size);

        //Delete Image from Cloudfare
        const response0 = await GetProductImageKeyById(
          image_idd,
          userID,
          userToken,
        );
        const data = await response0.data[0];
        // console.log(data);

        if (data && data.file_key_lg) {
          const response01 = await RemoveImage(
            data.file_key_lg,
            userID,
            userToken,
          );
          const response02 = await RemoveImage(
            data.file_key_sm,
            userID,
            userToken,
          );

          // console.log(response01, response02);
          if (response01.status !== 200 || response02.status !== 200) {
          }
        }

        var f_name = Name.substring(0, Math.min(50, Name.length))
          .split(" ")
          .join("_");
        f_name = f_name + "_" + i.toString() + "_";
        const response1 = await AddImage(
          f_name + "sm",
          "PRODUCT",
          compressedFile,
          userID,
          userToken,
        );
        const data1 = await response1.data;
        if (data1.imageUrl) {
          const response2 = await AddImage(
            f_name + "lg",
            "PRODUCT",
            compressedFile1,
            userID,
            userToken,
          );
          const data2 = await response2.data;
          if (data2.imageUrl) {
            const response = await EditProductImagesById(
              image_idd,
              i,
              null, //imggg,
              null, //imggg1,
              data2.fileKey,
              data1.fileKey,
              data2.publicUrl,
              data1.publicUrl,
              data2.imageUrl,
              data1.imageUrl,
              data2.cdnUrl,
              data1.cdnUrl,
              "",
              "",
              userID,
              userToken,
            );
            if (response.status === 200) {
              return true;
            } else {
              // alert("Product image failed to update!");
              return false;
            }
          } else {
            // alert("Product image failed to update!");
            return false;
          }
        } else {
          // alert("Product image failed to update!");
          return false;
        }
      }
    } catch (error) {
      console.error("Error compressing the image:", error);
      return false;
    }
  };

  const editImageNumber = async (imgg, image_idd) => {
    const s_id = oldImages.find((item) => item.image_id === image_idd);

    // console.log(oldImages, images);
    // console.log(s_id, imgg);

    if (s_id.id !== imgg) {
      try {
        const response = await EditProductImageNumberById(
          image_idd,
          imgg,
          userID,
          userToken,
        );
        if (response.status === 200) {
          return true;
        } else {
          return false;
          // alert("Product image failed to update.");
        }
      } catch (error) {
        console.error("Error compressing the image:", error);
        return false;
      }
    }
  };

  const removeImage = async (imgg, image_idd) => {
    try {
      //First remove from DB, return the address of CLOUDFLARE, Then call deleteImage from Cloudflare API

      const response = await RemoveProductImageById(
        image_idd,
        userID,
        userToken,
      );
      if (response.status === 200) {
        const data = await response.data[0];
        // console.log(data);

        if (data && data.file_key_lg) {
          const response1 = await RemoveImage(
            data.file_key_lg,
            userID,
            userToken,
          );
          const response2 = await RemoveImage(
            data.file_key_sm,
            userID,
            userToken,
          );

          // console.log(response1, response2);
          if (response1.status !== 200 || response2.status !== 200) {
            return false;
          }
          return true;
        }
      } else {
        return false;
        // alert("Product image failed to update.");
      }
    } catch (error) {
      console.error("Error compressing the image:", error);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    var resp = 0;
    try {
      setValError([]);
      const updatedErrors = [...ValError];

      if (Name === "") {
        updatedErrors[0] = "Please enter product name.";
        setValError(updatedErrors);
        return;
      }
      if (Name !== "") {
        if (validName1(Name, 0) === false) {
          return;
        }
      }
      updatedErrors[0] = "";

      if (Name2 !== "") {
        if (validName2(Name2, 10) === false) {
          return;
        }
      }
      updatedErrors[10] = "";

      if (Code === "") {
        updatedErrors[1] = "Please enter product code.";
        setValError(updatedErrors);
        return;
      }
      if (Code !== "") {
        if (ValidText1(Code, 1) === false) {
          return;
        }
      }
      updatedErrors[1] = "";

      await CheckProdNameCodeExist(Name, Code, userID, userToken)
        .then((resp) => {
          const pex = resp.data;
          if (Name1 !== Name) {
            if (pex[0].name === 1) {
              updatedErrors[0] = "Product name must be unique.";
              setValError(updatedErrors);
              return;
            }
            updatedErrors[0] = "";
          }
          if (Code1 !== Code) {
            if (pex[0].code === 1) {
              updatedErrors[1] = "Product code must be unique.";
              setValError(updatedErrors);
              return;
            }
            updatedErrors[1] = "";
          }
        })
        .catch((err) => {
          console.log(err.message);
        });

      if (UnitPrice === "") {
        updatedErrors[2] = "Please enter unit price.";
        setValError(updatedErrors);
        return;
      }
      if (UnitPrice < 0) {
        updatedErrors[2] = "Price must be greater than 0.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[2] = "";

      if (Discount === "") {
        updatedErrors[3] = "Please enter discount.";
        setValError(updatedErrors);
        return;
      }
      if (Discount < 0) {
        updatedErrors[3] = "Discount must be 0 or greater.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[3] = "";

      if (Details !== "") {
        if (ValidText1(Details, 7) === false) {
          return;
        }
      }
      updatedErrors[7] = "";

      if (Unit === "select" || Unit === "Select Unit") {
        updatedErrors[4] = "Please select unit.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[4] = "";

      if (Brand === "select" || Brand === "Select Brand") {
        updatedErrors[5] = "Please select brand.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[5] = "";

      if (Category === "select" || Category === "Select Category") {
        updatedErrors[6] = "Please select category.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[6] = "";

      const unit_id = Unit.value;
      const brand_id = Brand.value;
      const category_id = Category.value;
      var vid = null;
      // if (videoBlob) {
      //   vid = videoBlob;
      // }
      var tag_ids = [];
      Tag.forEach((element) => tag_ids.push(element.value));
      var Tgs = { tags: tag_ids };

      const response = await EditProductApi(
        param.p_id,
        Code,
        Name,
        Name2,
        Details,
        UnitPrice,
        Discount,
        unit_id,
        category_id,
        brand_id,
        DisplayProduct,
        ActiveProduct,
        vid,
        vflag,
        Tgs,
        userID,
        userToken,
      );
      //console.log(response, "Response");
      //console.log(images);
      resp = response.status;
      if (resp === 200) {
        //console.log(images);
        if (editImg === true) {
          var ress = true;
          var ress1 = true;
          // console.log(images);
          for (const element of images) {
            // console.log(element);
            if (element.image_id === null && element.preview !== null) {
              // console.log("0");
              ress1 = await insertImage(element.file, element.id);
            } else if (
              element.image_id === null &&
              element.file === null &&
              element.preview === null &&
              element.image === null
            ) {
              // console.log("1");
              // } else if (element.file) {
            } else if (
              element.image_id !== null &&
              element.file === null &&
              element.url === null &&
              element.preview === null
            ) {
              ress1 = await removeImage(element.id, element.image_id);
              // console.log("4");
            } else if (element.url === null && element.image_id !== null) {
              ress1 = await updateImage(
                element.file,
                element.image_id,
                element.id,
              );
              // console.log("2");
              // } else if (!element.file && !element.preview) {
              //   updateImage(element.file, element.image_id, element.id);
              //   console.log("3");
            } else if (sortImage === true && element.image_id !== null) {
              ress1 = await editImageNumber(element.id, element.image_id);
              // console.log("5");
            } else {
              // console.log("6");
            }
            ress = ress && ress1;
          }
        }
        if (editImg === true) {
          if (ress) {
            alert(
              "Product updated successfully!\n\nImages updated successfully!",
            );
          } else {
            alert("Product updated successfully!\n\nImage/s may not updated!");
          }
        } else {
          alert("Product updated successfully!");
        }
      } else {
        alert("Product failed to update.");
      }
    } catch (err) {
    } finally {
      setLoadBtn(false);
      if (resp === 200) {
        navigate("/Product");
      }
    }
  };

  // useEffect(() => {
  //   async function fetchData() {

  //   }
  //   fetchData();
  // }, [Code, Name]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (param.p_id && userID && userToken && productImageLimit) {
        await GetAllUnits(userID, userToken)
          .then((resp) => {
            const unitOptions = resp.data.map((item) => ({
              label: item.names,
              value: item.unit_id,
            }));
            setUnits(unitOptions || []);
          })
          .catch((err) => {
            console.log(err.message);
          });

        await GetAllBrands(userID, userToken)
          .then((resp) => {
            const brandOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.brand_id,
            }));
            setbrands(brandOptions || []);
          })
          .catch((err) => {
            console.log(err.message);
          });

        await GetAllCategories(userID, userToken)
          .then((resp) => {
            const categOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.category_id,
            }));
            setCategories(categOptions || []);
          })
          .catch((err) => {
            console.log(err.message);
          });

        await GetAllTags(userID, userToken)
          .then((resp) => {
            const tagOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.tag_id,
            }));
            setTags(tagOptions || []);
          })
          .catch((err) => {
            console.log(err.message);
          });

        //console.log(param.p_id);
        const resp1 = GetProductById(param.p_id, userID, userToken);
        resp1
          .then(function (result) {
            //console.log(result.data);
            setName(result.data[0].name);
            setName2(result.data[0].name2);
            setCode(result.data[0].code);
            setName1(result.data[0].name);
            setCode1(result.data[0].code);
            setDetails(result.data[0].details);
            setDiscount(result.data[0].discount);
            setUnitPrice(result.data[0].unit_price);
            setDiscount(result.data[0].discount);
            setDisplayProduct(result.data[0].display_product);
            setActiveProduct(result.data[0].active_product);
            // setDisplayProduct(1);
            // setActiveProduct(1);
            setUnit({
              label: result.data[0].units,
              value: result.data[0].unit_id,
            });
            setBrand({
              label: result.data[0].brand,
              value: result.data[0].brand_id,
            });
            setCategory({
              label: result.data[0].category,
              value: result.data[0].category_id,
            });
            const tagOptions = result.data[0].tags.map((item) => ({
              label: item.tag,
              value: item.tag_id,
            }));
            setTag(tagOptions);

            // if (result.data[0].video !== null) {
            //   setflag(true);
            // }
            //setVideoBlob1("data:video/mp4;base64," + result.data[0].video);
            setvflag(0);
            // setVideoBlob2(result.data[0].video);
          })
          .catch((err) => {
            console.log(err.message);
          });

        //   const resp2 = GetProductVideoById(param.p_id);
        // resp2
        //   .then(function (result) {
        //     console.log(result.data);
        //     setVideoBlob("data:video/mp4;base64," + result.data[0].video.Blob());

        //   })
        //   .catch((err) => {
        //     console.log(err.message);
        //   });
        //   const resp2 = GetProductImagesById(param.p_id, userID, userToken);
        // resp2
        //   .then(function (result) {
        //     setProdImage(result.data[0].image);
        //   })
        //   .catch((err) => {
        //     console.log(err.message);
        //   });

        GetProductImagesById(param.p_id, userID, userToken).then(
          function (result) {
            //console.log(result.data);
            if (result.data) {
              var productimg = [];
              for (let i = 1; i < productImageLimit + 1; i++) {
                const imggg = result.data.find((item) => item.number === i);

                if (imggg) {
                  productimg.push({
                    id: i,
                    file: null,
                    preview: "data:image/jpeg;base64," + imggg.image,
                    image_id: imggg.image_id,
                    image: imggg.image,
                    url: imggg.cdn_url_sm,
                    remove: "❌",
                  });
                } else {
                  productimg.push({
                    id: i,
                    file: null,
                    preview: null,
                    image_id: null,
                    image: null,
                    url: null,
                    remove: "❌",
                  });
                }
              }
              // productimg = result.data.map((item) => ({
              //   id: item.image_ids,
              //   file: null,
              //   preview: "data:image/jpeg;base64," + item.image,
              //   image_id: item.image_id,
              //   image: item.image,
              //   url: item.cdn_url_sm,
              //   remove: "❌",
              // }));
              // const emptyImageCards = Array.from(
              //   { length: Math.max(0, 4 - productimg.length) },
              //   // { length: Math.max(0, 1 - productimg.length) },
              //   (_, index) => ({
              //     id: productimg.length + index + 1,
              //     file: null,
              //     preview: null,
              //     image_id: null,
              //     image: null,
              //     url: null,
              //     remove: "❌",
              //   })
              // );
              const productimgOld = result.data.map((item) => ({
                id: item.number,
                image_id: item.image_id,
                url: item.cdn_url_sm,
              }));
              //console.log(productimg);
              // setImages([...productimg, ...emptyImageCards]);
              setImages([...productimg]);
              setOldImages([...productimgOld]);
              // setVisibleCard(productimg.length + 1);
            }
          },
        );
      }
    }
    fetchData();
  }, [param.p_id, userID, userToken, productImageLimit]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header title="EDIT PRODUCT" />
      <form>
        <Container
          className="g-0 justify-center"
          fluid="true"
          style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
        >
          <Row xs={1} sm={1} style={{ padding: "0" }}>
            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Name: </label>
                  <br />
                  <input
                    required
                    type="text"
                    name="Name"
                    onChange={handleChangeName}
                    value={Name}
                    placeholder="Name"
                    className="input"
                    autoFocus
                    maxLength={99}
                    onBlur={(e) => validName1(e.target.value, 0)}
                  />
                  <span className="label-imp">*</span>
                  {ValError[0] && <p className="label-error">{ValError[0]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Other Name:</label>
                  <input
                    dir="rtl"
                    type="text"
                    name="Name2"
                    placeholder="اردو نام"
                    value={Name2}
                    onChange={handleChangeName2}
                    className="input"
                    maxLength={199}
                    onBlur={(e) => validName2(e.target.value, 10)}
                  />
                  {/* <span className="label-imp">*</span> */}
                  {ValError[10] && (
                    <p className="label-error">{ValError[10]}</p>
                  )}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Code: </label>
                  <br />
                  <input
                    required
                    type="text"
                    name="Code"
                    onChange={handleChangeCode}
                    value={Code}
                    placeholder="Code"
                    className="input"
                    maxLength={14}
                    onBlur={(e) => ValidText1(e.target.value, 1)}
                  />
                  <span className="label-imp">*</span>
                  {ValError[1] && <p className="label-error">{ValError[1]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Unit Price: </label>
                  <br />
                  <input
                    type="number"
                    min="0"
                    // defaultValue={0}
                    step="1.00"
                    name="UnitPrice"
                    onChange={handleChangeUnitPrice}
                    value={UnitPrice}
                    placeholder="Price"
                    className="input"
                  />
                  <span className="label-imp">*</span>
                  {ValError[2] && <p className="label-error">{ValError[2]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Discount: </label>
                  <br />
                  <input
                    type="number"
                    min="0"
                    // defaultValue={0}
                    step="1.00"
                    name="Discount"
                    onChange={handleChangeDiscount}
                    value={Discount}
                    placeholder="Discount"
                    className="input"
                  />
                  <span className="label-imp">*</span>
                  {ValError[3] && <p className="label-error">{ValError[3]}</p>}
                </div>
              </div>
              <br />

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Description: </label>
                  <textarea
                    placeholder="Description"
                    id="noteTextarea"
                    value={Details}
                    onChange={handleChangeDetails}
                    rows="4"
                    maxLength={499}
                    className="textarea"
                    onBlur={(e) => ValidText1(e.target.value, 7)}
                  />
                  {ValError[7] && <p className="label-error">{ValError[7]}</p>}
                </div>
              </div>
              <br />
              <br />
            </Col>
            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="UnitSelect">
                    Unit:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      inputId="UnitSelect"
                      className="myreact-select container-select"
                      value={Unit}
                      onChange={handleChangeUnit}
                      options={getunits}
                    ></Select>
                    <span className="label-imp-select-prd">*</span>
                  </div>
                  {ValError[4] && <p className="label-error">{ValError[4]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="BrandSelect">
                    Brand:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      inputId="BrandSelect"
                      className="myreact-select container-select"
                      value={Brand}
                      onChange={handleChangeBrand}
                      options={getbrands}
                    ></Select>
                    <span className="label-imp-select-prd">*</span>
                  </div>
                  {ValError[5] && <p className="label-error">{ValError[5]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="CategorySelect">
                    Category:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      inputId="CategorySelect"
                      className="myreact-select container-select"
                      value={Category}
                      onChange={handleChangeCategory}
                      options={getcategories}
                    ></Select>
                    <span className="label-imp-select-prd">*</span>
                  </div>
                  {ValError[6] && <p className="label-error">{ValError[6]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="TagSelect">
                    Tag:
                  </label>
                  <div className="flex mb-2">
                    <Select
                      inputId="TagSelect"
                      className="myreact-select container-select"
                      value={Tag}
                      onChange={handleChangeTag}
                      options={gettags}
                      isMulti
                    ></Select>
                    <span className="label-imp-select-prd"></span>
                  </div>
                  {ValError[11] && (
                    <p className="label-error">{ValError[11]}</p>
                  )}
                </div>
              </div>
              <br />
              <br />
              <label className="label-checkbox">
                <input
                  type="checkbox"
                  value="ActiveProduct"
                  checked={ActiveProduct === 1}
                  onChange={handleChangeActive}
                />
                {` `} Active Product
              </label>
              <label className="label-checkbox">
                <input
                  type="checkbox"
                  value="DisplayProduct"
                  checked={DisplayProduct === 1}
                  onChange={handleChangeDisplay}
                />
                {` `} Display Product
              </label>
              <br />

              {/* <div className="mt-3 col-lg-12">
                <div className="form-group">
                  <label className="label">Video:</label>
                  <div>
                    {loading && <p>Loading...</p>}
                    {flag && (
                      <div>
                        {videoBlob1 && (
                          <div className="container-video-div">
                            <video
                              controls
                              src={videoBlob1}
                              type="video/mp4"
                              className="container-video"
                              alt={`Product Video`}
                            />
                            <button
                              className="crs-btn"
                              type="button"
                              onClick={handleClickRemoveVideo}
                            >
                              ❌
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                    {videoBlob && (
                      <div className="container-video-div">
                        <video
                          controls
                          src={URL.createObjectURL(videoBlob)}
                          type="video/mp4"
                          className="container-video"
                          alt={`Product Video`}
                        />
                        <button
                          className="crs-btn"
                          type="button"
                          onClick={handleClickRemoveVideo}
                        >
                          ❌
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="mt-1 product-image-input">
                    <input
                      title=" "
                      ref={fileInputRef}
                      type="file"
                      accept="video/*"
                      onChange={handleVideoFileChange}
                    />
                  </div>
                </div>
              </div>
              <br /> */}
              <br />
            </Col>
            {productImageLimit > 0 && (
              <Col md={4} className="container-col">
                <label className="label-checkbox">
                  <input
                    type="checkbox"
                    value="EditImg"
                    checked={editImg === true}
                    onChange={handleChangeEditImg}
                  />
                  {` `} Change Images
                </label>
                <div className="mt-0 col-lg-12">
                  {images.map((image, index) => (
                    <div
                      key={image.id}
                      // style={{
                      //   display: visibleCard >= image.id ? "flex" : "none",
                      // }}
                      draggable
                      onDragStart={() => (dragImage.current = index)}
                      onDragEnter={() => (draggedOverImage.current = index)}
                      onDragEnd={handleSort}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      <div className="container-video-div">
                        {image.url ? (
                          <img
                            className="container-image"
                            src={image.url}
                            alt={`Product ${image.id}`}
                          />
                        ) : (
                          image.preview && (
                            <img
                              className="container-image"
                              src={image.preview}
                              alt={`Product ${image.id}`}
                            />
                          )
                        )}

                        <div className="crs-btn-image">
                          {(image.url || image.preview) && (
                            <button
                              type="button"
                              onClick={(e) =>
                                handleClickRemoveImage(image.id, fileInputRef)
                              }
                              disabled={editImg === false}
                            >
                              {image.remove}
                            </button>
                          )}
                          <div className="product-image-label">
                            <label
                              className="container-label"
                              htmlFor={`imageInput${image.id}`}
                            >{`Image ${image.id}:`}</label>
                          </div>
                          <div className="product-image-input">
                            {/* {image.id === 1 && ( */}
                            <input
                              ref={(ref) => {
                                fileInputRef.current[index] = ref;
                              }}
                              className="flex justify-left"
                              type="file"
                              id={`imageInput${image.id}`}
                              accept="image/*"
                              onChange={(e) =>
                                handleImageChange(e, image.id, fileInputRef)
                              }
                              disabled={editImg === false}
                            />
                            {/*)}
                          {image.id === 2 && (
                            <input
                              ref={fileInputImgRef2}
                              className="flex justify-left"
                              type="file"
                              id={`imageInput${image.id}`}
                              accept="image/*"
                              onChange={(e) => handleImageChange(e, image.id)}
                              disabled={editImg === false}
                            />
                          )}
                          {image.id === 3 && (
                            <input
                              ref={fileInputImgRef3}
                              className="flex justify-left"
                              type="file"
                              id={`imageInput${image.id}`}
                              accept="image/*"
                              onChange={(e) => handleImageChange(e, image.id)}
                              disabled={editImg === false}
                            />
                          )}
                          {image.id === 4 && (
                            <input
                              ref={fileInputImgRef4}
                              className="flex justify-left"
                              type="file"
                              id={`imageInput${image.id}`}
                              accept="image/*"
                              onChange={(e) => handleImageChange(e, image.id)}
                              disabled={editImg === false}
                            />
                          )} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <br />
                <br />
              </Col>
            )}
          </Row>
        </Container>
      </form>
      {/* <button >Submit</button> */}
      <Row md={"auto"} className="justify-content-center">
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button"
          bgColor={currentColor}
          text="Update"
          borderRadius="10px"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button"
          bgColor={currentColor}
          text="Back"
          borderRadius="10px"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default EditProduct;
